/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Tea_Lot_DateInputs */

const vi_trace_tea_lot_date = /** @type {(inputs: Trace_Tea_Lot_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày lập lô`)
};

/**

* @param {Trace_Tea_Lot_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_tea_lot_date = /** @type {((inputs?: Trace_Tea_Lot_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Tea_Lot_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_tea_lot_date(inputs)
});